module.exports = __webpack_public_path__ + "img/Perlis.80dcd717.png";